import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

// Fetches a CMS page-content singleton (home, partner, etc.). Returns { content, loading }.
// Refetches on SPA navigation (location.key) with a cache-buster so admin edits show immediately.
export function usePageContent(pageId) {
  const { key } = useLocation();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api.get(`/public/content/${pageId}`, { params: { t: Date.now() } })
      .then((r) => { if (!cancelled) setContent(r.data); })
      .catch(() => { if (!cancelled) setContent(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [pageId, key]);
  return { content, loading };
}
